export class RedirectHelper {

    public static redirectTo(url: string): void {

        window.location.href = url;
    }
}
